import React, { ReactNode } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Button, styled } from '@mui/material';

type Props = {
  id: string;
  anchorEl: HTMLElement | null;
  numberOfSelectedOptions: number;
  disabled?: boolean;
  children: ReactNode | string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const ButtonStyled = styled(Button)(({ theme }) => ({
  background: 'white',
  padding: '16px 30px',
  textTransform: 'capitalize',
  borderColor: theme.palette.primary.main,
  border: '1px solid',
  fontSize: '16px',
  fontWeight: '400',
  borderRadius: '10px',
  '&:disabled': {
    borderColor: theme.palette.primary.main,
    border: '1px solid',
  },
  '& > span': {
    fontSize: '0.9em',
  },
  '&:hover .MuiSvgIcon-root': {
    color: theme.palette.primary.light,
  },
  '&:hover .circle-number': {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.light,
  },
}));
const CircleNumberBoxStyled = styled(Box)(({ theme }) => ({
  padding: '2px 8px',
  borderRadius: '64px',
  backgroundColor: `${theme.palette.primary.main}`,
  color: `${theme.palette.primary.light}`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '12px',
  marginRight: '8px',
}));

export function FilterButton({
  id,
  anchorEl,
  numberOfSelectedOptions,
  onClick,
  children,
  disabled,
}: Props) {
  return (
    <ButtonStyled
      aria-controls="simple-menu"
      aria-haspopup="true"
      data-testid={`${id}-btn`}
      onClick={onClick}
      variant="outlined"
      color="primary"
      size="medium"
      disabled={disabled}
      endIcon={
        <ExpandMoreIcon
          sx={{
            color: 'primary.main',
            userSelect: 'none',
            pointerEvents: 'none',
            transform: anchorEl ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
        />
      }
    >
      {Boolean(numberOfSelectedOptions) && (
        <CircleNumberBoxStyled className="circle-number">
          {numberOfSelectedOptions}
        </CircleNumberBoxStyled>
      )}
      {children}
    </ButtonStyled>
  );
}
